import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-group-enrollments-modal',
  templateUrl: './group-enrollments-modal.component.html',
  styles: [':host{ height: 100%; }'],
})
export class GroupEnrollmentsModalComponent {
  @Input() groupId: string;
  @Input() isReadOnly = false;

  constructor(private activeModal: NgbActiveModal) {}

  close() {
    this.activeModal.close();
  }
}
